<template>
    <v-dialog :model-value="modelValue" persistent width="520"
              @update:model-value="$emit('update:modelValue', $event)">
        <v-card>
            <v-card-title class="d-flex justify-space-between align-center">
                <span>Upload document</span>
                <v-btn icon="mdi-close" variant="text" density="compact" @click="close"/>
            </v-card-title>

            <v-form v-model="valid" @submit.prevent="save">
                <v-card-text>
                    <v-text-field v-model="form.name" :rules="[v => !!v || 'Name is required']"
                                  density="compact" label="Name *" autofocus/>
                    <v-row dense>
                        <v-col cols="12" sm="7">
                            <v-combobox v-model="form.doc_type" :items="docTypes" density="compact"
                                        label="Type" clearable/>
                        </v-col>
                        <v-col cols="12" sm="5">
                            <v-text-field v-model="form.expires_on" type="date" density="compact"
                                          label="Expires on" clearable/>
                        </v-col>
                    </v-row>
                    <v-file-input v-model="form.document" accept=".pdf,image/*,.doc,.docx,.xls,.xlsx"
                                  :rules="[v => (v && (Array.isArray(v) ? v.length : true)) || 'A file is required']"
                                  density="compact" prepend-icon="mdi-paperclip" label="File *" show-size/>
                    <v-textarea v-model="form.notes" density="compact" rows="2" label="Notes"/>
                </v-card-text>

                <v-card-actions class="px-4 pb-3 d-flex justify-end">
                    <v-btn variant="text" @click="close">Cancel</v-btn>
                    <v-btn color="primary" type="submit" :loading="saving" :disabled="!valid">Upload</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script setup>
import {reactive, ref} from "vue";
import {refreshMenuCounts} from "@/composables/useMenuCounts";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const props = defineProps({
    modelValue: Boolean,
    driverId: {type: [String, Number], required: true},
});
const emit = defineEmits(["update:modelValue", "saved"]);
const {showSnackbar} = useSnackbarStore();

const valid = ref(false);
const saving = ref(false);
const form = reactive({name: null, doc_type: null, expires_on: null, notes: null, document: null});
const docTypes = ['License', 'Medical Certificate', 'Insurance', 'Registration', 'Certification', 'Other'];

const close = () => emit("update:modelValue", false);

const save = () => {
    if (!valid.value || !form.document) return;
    saving.value = true;

    const fd = new FormData();
    fd.append("name", form.name);
    if (form.doc_type) fd.append("doc_type", form.doc_type);
    if (form.expires_on) fd.append("expires_on", form.expires_on);
    if (form.notes) fd.append("notes", form.notes);
    fd.append("document", form.document);

    send("post", `companies/drivers/${props.driverId}/documents`, fd, {headers: {"Content-Type": "multipart/form-data"}})
        .then((response) => {
            showSnackbar(response.data.message);
            emit("saved", response.data.data);
            refreshMenuCounts();
            close();
        })
        .catch((error) => {
            const msg = error.response?.data?.errors
                ? Object.values(error.response.data.errors)[0][0]
                : (error.response?.data?.message ?? "Could not upload document");
            showSnackbar(msg, "error");
        })
        .finally(() => saving.value = false);
};
</script>
